/*
 * LAO Care, 25/10/2026 : volet panier à paliers (maquette validée par Lisa le 25/10/2026).
 * - Contenu (lignes, prix, remises, cadeaux) rendu par Shopify : sections/lao-panier-api.liquid, jamais recalculé ici.
 * - Ici : ouverture du volet, barre de paliers à jalons équidistants, bandeau d'offres, bandeau « routine sur mesure »,
 *   code de réduction, cadeaux Gift Box (retirer / remettre), cliente ou non (échantillon réservé aux nouvelles clientes).
 * - Tout seuil, date et texte vient des réglages du thème (snippets/lao-panier-config.liquid).
 * - Relit le panier après CHAQUE changement, y compris ceux faits par l'appli Gift Box (événements qu'elle émet).
 */
(function () {
  'use strict';

  var racine = document.getElementById('lao-panier');
  var cfgEl = document.getElementById('lao-panier-config');
  if (!racine || !cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.actif) return;

  var SECTION = 'lao-panier-api';
  var CLE_CLIENTE = 'lao-panier-cliente';
  var CLE_RETIRES = 'lao-panier-cadeaux-retires';
  var CLE_GIFTBOX = 'giftbox-added-offers';
  var DUREE_RETIRE = 30 * 864e5; // le refus noté chez Gift Box n'expire pas : on garde « le remettre » 30 jours
  var DRAPEAUX = '<span class="lao-drapeaux" role="img" aria-label="France, Belgique, Luxembourg">' +
    '<svg viewBox="0 0 3 2" aria-hidden="true" focusable="false"><rect width="1" height="2" fill="#0055A4"/><rect x="1" width="1" height="2" fill="#fff"/><rect x="2" width="1" height="2" fill="#EF4135"/></svg>' +
    '<svg viewBox="0 0 3 2" aria-hidden="true" focusable="false"><rect width="1" height="2" fill="#000"/><rect x="1" width="1" height="2" fill="#FDDA24"/><rect x="2" width="1" height="2" fill="#EF3340"/></svg>' +
    '<svg viewBox="0 0 3 2" aria-hidden="true" focusable="false"><rect width="3" height=".67" fill="#EF3340"/><rect y=".67" width="3" height=".67" fill="#fff"/><rect y="1.33" width="3" height=".67" fill="#00A3E0"/></svg></span>';

  function $(sel) { return racine.querySelector(sel); }
  var volet = $('.lao-panier__volet');
  var zone = $('[data-lao-zone-contenu]');

  // ── Outils ────────────────────────────────────────────────────────────────
  function echapper(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function norm(s) { return String(s || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function lireStockage(cle, defaut) { try { var v = localStorage.getItem(cle); return v ? JSON.parse(v) : defaut; } catch (e) { return defaut; } }
  function ecrireStockage(cle, v) { try { if (v == null) localStorage.removeItem(cle); else localStorage.setItem(cle, JSON.stringify(v)); } catch (e) { /* navigation privée */ } }
  function url(route, suffixe) { return String(route || '').replace(/\/$/, '') + (suffixe || ''); }

  var donnees = null;          // dernier état rendu par Shopify (snippets/lao-panier-contenu.liquid)
  var codesPanier = [];        // [{code, applicable}] lus dans /cart.js
  var seq = 0;                 // seule la réponse la plus récente est affichée
  var file = Promise.resolve();
  var tentativesRetrait = {};

  // ── Heure de Paris (dates des réglages : « AAAA-MM-JJ HH:MM ») ────────────
  var fmtParis = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  function decalageParis(ms) {
    var p = {};
    fmtParis.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - Math.floor(ms / 1000) * 1000;
  }
  function parisVersMs(texte) {
    var m = /^\s*(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2})(?::(\d{2}))?)?\s*$/.exec(String(texte || ''));
    if (!m) return NaN;
    var naif = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    var d1 = decalageParis(naif);
    var d2 = decalageParis(naif - d1);
    return naif - d2;
  }
  // Date simulée (?lao_date=2026-11-10T10:00) : UNIQUEMENT sur un thème non publié (aperçu), jamais en ligne.
  function maintenant() {
    try {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (role && role !== 'main') {
        var p = new URLSearchParams(location.search).get('lao_date');
        if (p === 'off') sessionStorage.removeItem('lao-panier-date');
        else if (p) sessionStorage.setItem('lao-panier-date', p);
        var s = sessionStorage.getItem('lao-panier-date');
        if (s) { var t = parisVersMs(s); if (!isNaN(t)) return t; }
      }
    } catch (e) { /* rien */ }
    return Date.now();
  }
  function dateInvalide(texte) {
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (window.console && role !== 'main') console.warn('[LAO panier] date de réglage illisible (attendu AAAA-MM-JJ HH:MM, heure de Paris) : « ' + texte + ' » ; offre masquée.');
  }
  function dansFenetre(debut, fin, t) {
    if (debut && String(debut).trim()) { var d = parisVersMs(debut); if (isNaN(d)) { dateInvalide(debut); return false; } if (t < d) return false; }
    if (fin && String(fin).trim()) { var f = parisVersMs(fin); if (isNaN(f)) { dateInvalide(fin); return false; } if (t >= f + 60000) return false; }
    return true;
  }

  // ── Cliente ou nouvelle cliente ───────────────────────────────────────────
  (function noterMarqueur() {
    try {
      var v = new URLSearchParams(location.search).get(CFG.cliente.param || 'lc');
      if (v == null) return;
      if (v === String(CFG.cliente.valeur || 'cl')) ecrireStockage(CLE_CLIENTE, { jusqua: Date.now() + (Number(CFG.cliente.jours) || 90) * 864e5 });
      else if (v === 'nv') ecrireStockage(CLE_CLIENTE, null);
    } catch (e) { /* rien */ }
  })();
  function estCliente() {
    if (donnees && donnees.client && donnees.client.cliente) return true;
    var m = lireStockage(CLE_CLIENTE, null);
    return !!(m && m.jusqua > Date.now());
  }

  // ── Argent ────────────────────────────────────────────────────────────────
  function devise() { return (donnees && donnees.devise) || CFG.devise || 'EUR'; }
  function argent(cents) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise() }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function seuilCents(euros) {
    var taux = 1;
    if (devise() !== CFG.deviseBoutique) { taux = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; }
    return Math.round(Number(euros) * 100 * taux);
  }

  // ── Règles d'affichage ────────────────────────────────────────────────────
  function etatDuJour() {
    var t = maintenant();
    var cliente = estCliente();
    var pause = !!(CFG.pause && CFG.pause.actif && dansFenetre(CFG.pause.debut, CFG.pause.fin, t));
    var offres = (CFG.offres || []).filter(function (o) { return o.actif && dansFenetre(o.debut, o.fin, t); });
    var skusOffres = offres.filter(function (o) { return Number(o.seuil) > 0 && o.sku; }).map(function (o) { return norm(o.sku); });

    var points = pause ? Number(CFG.pause.routinePoints) || 0 : 0;
    var routine = ((CFG.routine && CFG.routine.paliers) || [])
      .filter(function (p) { return Number(p.q) > 0; })
      .map(function (p) { return { q: Number(p.q), t: Number(p.t) + points }; })
      .sort(function (a, b) { return a.q - b.q; });
    var routineMax = routine.length ? routine[routine.length - 1].t : 0;

    var jalons = [];
    var liv = CFG.livraison || {};
    var paysLivraison = String(liv.pays || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
    var livraisonIci = !paysLivraison.length || !CFG.pays || paysLivraison.indexOf(String(CFG.pays).toUpperCase()) >= 0;
    if (liv.actif && livraisonIci && Number(liv.seuil) > 0) jalons.push({ cle: 'livraison', seuil: Number(liv.seuil), legende: liv.legende, message: liv.message, drapeaux: true });
    var permanents = [];
    if (!pause) {
      (CFG.paliers || []).forEach(function (p) {
        if (!p.actif || !(Number(p.seuil) > 0)) return;
        if (!dansFenetre(p.debut, p.fin, t)) return;
        if (p.nouvellesSeulement && cliente) return;
        if (p.sku && skusOffres.indexOf(norm(p.sku)) >= 0) return; // l'offre du moment le remplace : jamais deux jalons pour le même cadeau
        var j = { cle: p.cle, seuil: Number(p.seuil), legende: p.legende, message: p.message, sku: p.sku, cadeau: true, bandeau: p.bandeau };
        jalons.push(j); permanents.push(j);
      });
    }
    offres.forEach(function (o) { if (Number(o.seuil) > 0) jalons.push({ cle: o.cle, seuil: Number(o.seuil), legende: o.legende, message: o.message, sku: o.sku, cadeau: true }); });
    jalons.sort(function (a, b) { return a.seuil - b.seuil; });

    var remplacer = function (texte, seuil) {
      return echapper(texte)
        .replace(/\{seuil\}/g, seuil ? echapper(argent(seuilCents(seuil)).replace(/,00(?=\s?\D*$)/, '')) : '')
        .replace(/\{drapeaux\}/g, DRAPEAUX)
        .replace(/\{routine_max\}/g, String(routineMax).replace('.', ','));
    };
    var bandeau = [];
    if (pause && CFG.pause.bandeau) bandeau.push(remplacer(CFG.pause.bandeau));
    offres.forEach(function (o) { if (o.bandeau) bandeau.push(remplacer(o.bandeau, o.seuil)); });
    if (liv.actif && livraisonIci && liv.bandeau && Number(liv.seuil) > 0) bandeau.push(remplacer(liv.bandeau, liv.seuil));
    permanents.forEach(function (p) { if (p.bandeau) bandeau.push(remplacer(p.bandeau, p.seuil)); });

    return { t: t, cliente: cliente, pause: pause, jalons: jalons, bandeau: bandeau, routine: routine };
  }

  // ── Rendu ─────────────────────────────────────────────────────────────────
  function lireDonnees(conteneur) {
    var s = conteneur && conteneur.querySelector('[data-lao-donnees]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  // Appartenance aux collections « produits à l'unité » et « routines prêtes » : lue aussi dans /collections/<handle>/products.json
  // (copie de 30 min dans le navigateur), car le rendu des sections du panier par Shopify ne voit pas toujours les collections
  // publiées récemment (constat du 25/10/2026 : « unitaire » faux dans la réponse de /cart/change.js, juste dans GET /cart).
  var membres = { unitaires: {}, routines: {} };
  function chargerCollection(handle) {
    if (!handle) return Promise.resolve({});
    var cle = 'lao-panier-collection:' + handle;
    try { var c = JSON.parse(sessionStorage.getItem(cle) || 'null'); if (c && Date.now() - c.le < 30 * 60000) return Promise.resolve(c.ids); } catch (e) { /* rien */ }
    var ids = {};
    var page = function (n) {
      return fetch((CFG.routes.racine || '/').replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var p = (j && j.products) || [];
          p.forEach(function (x) { ids[String(x.id)] = true; });
          return p.length === 250 && n < 4 ? page(n + 1) : ids;
        });
    };
    return page(1).then(function (r) { try { sessionStorage.setItem(cle, JSON.stringify({ le: Date.now(), ids: r })); } catch (e) { /* rien */ } return r; }).catch(function () { return {}; });
  }
  function chargerCollections() {
    var r = CFG.routine || {};
    Promise.all([chargerCollection(r.collection), chargerCollection(r.routinesPretes)]).then(function (res) {
      membres.unitaires = res[0] || {}; membres.routines = res[1] || {};
      rendre();
    });
  }
  function estUnitaire(l) { return !!(l.unitaire || membres.unitaires[String(l.produit)]); }
  function estRoutinePrete(l) { return !!(l.routine || membres.routines[String(l.produit)]); }

  function rendreRoutine(etat) {
    var el = $('[data-lao-routine]');
    var lignes = (donnees && donnees.lignes) || [];
    var nb = lignes.filter(function (l) { return estUnitaire(l) && !l.cadeau; }).reduce(function (s, l) { return s + l.qte; }, 0);
    if (!CFG.routine || !CFG.routine.actif || !nb || !etat.routine.length) { el.innerHTML = ''; return; }
    var actif = null, prochain = null;
    etat.routine.forEach(function (p) { if (nb >= p.q) actif = p; else if (!prochain) prochain = p; });
    var bundle = lignes.some(function (l) { return estRoutinePrete(l) && !l.cadeau; });
    var dernier = etat.routine[etat.routine.length - 1];
    var pct = function (n) { return String(n).replace('.', ','); };
    var cases = etat.routine.map(function (p) {
      var ok = actif && actif.q === p.q;
      return '<span class="' + (ok ? 'est-atteint' : '') + '"' + (ok ? ' aria-current="true"' : '') + '>' + p.q + (p === dernier ? '+' : '') + ' produits<br>−' + pct(p.t) + ' %</span>';
    }).join('');
    var manque = prochain ? prochain.q - nb : 0;
    el.innerHTML = '<div class="lao-routine">' +
      '<div class="lao-routine__tete"><strong>Routine sur mesure</strong><span>' + nb + ' produit' + (nb > 1 ? 's' : '') + '</span></div>' +
      '<div class="lao-routine__paliers">' + cases + '</div>' +
      '<div class="lao-routine__note">Sur les produits à l\'unité' + (bundle ? ' (pas sur les routines prêtes, déjà réduites)' : '') + '</div>' +
      '<div class="lao-routine__message">' + (prochain
        ? 'Ajoutez ' + manque + ' produit' + (manque > 1 ? 's' : '') + ' pour passer à <strong>−' + pct(prochain.t) + ' %</strong>'
        : 'Vous profitez de la remise maximale de −' + pct(dernier.t) + ' %') + '</div></div>';
  }

  function rendrePaliers(etat) {
    var bloc = $('[data-lao-paliers]');
    var lignes = (donnees && donnees.lignes) || [];
    var total = (donnees && donnees.total) || 0;
    var ech = palierEchantillon() || {};
    var seulEchantillon = lignes.length > 0 && ech.sku && lignes.every(function (l) { return !l.cadeau && norm(l.sku) === norm(ech.sku); });
    var liste = etat.jalons;
    if (!liste.length || seulEchantillon) { bloc.hidden = true; return; }
    bloc.hidden = false;
    var n = liste.length;
    var cadeaux = liste.some(function (j) { return j.cadeau; });
    var avecLivraison = liste.some(function (j) { return j.cle === 'livraison'; });
    var prochain = null;
    for (var i = 0; i < n; i++) { if (total < seuilCents(liste[i].seuil)) { prochain = liste[i]; break; } }
    var msg;
    if (!lignes.length) msg = cadeaux ? 'Ajoutez un produit pour débloquer vos cadeaux' : 'Ajoutez un produit pour profiter de la livraison offerte';
    else if (prochain) msg = 'Plus que <strong>' + echapper(argent(seuilCents(prochain.seuil) - total)) + '</strong> ' + echapper(prochain.message || '');
    else if (cadeaux && avecLivraison) msg = 'Bravo, tous vos cadeaux sont débloqués et la livraison est offerte';
    else if (cadeaux) msg = 'Bravo, tous vos cadeaux sont débloqués';
    else msg = 'Bravo, la livraison en point relais vous est offerte';
    $('[data-lao-palier-message]').innerHTML = msg;

    var rempli = 100;
    for (var k = 0; k < n; k++) {
      var avant = k === 0 ? 0 : seuilCents(liste[k - 1].seuil);
      var s = seuilCents(liste[k].seuil);
      if (total < s) { rempli = ((k + (total - avant) / Math.max(1, s - avant)) / n) * 100; break; }
    }
    $('[data-lao-remplie]').style.width = Math.max(0, Math.min(100, rempli)) + '%';
    var piste = $('[data-lao-piste]');
    Array.prototype.forEach.call(piste.querySelectorAll('.lao-jalon'), function (x) { x.remove(); });
    var leg = $('[data-lao-legendes]');
    leg.innerHTML = '';
    leg.classList.toggle('lao-legendes--serre', n >= 3);
    leg.classList.toggle('lao-legendes--tres-serre', n >= 4);
    liste.forEach(function (j, idx) {
      var pos = ((idx + 1) / n) * 100;
      var ok = total >= seuilCents(j.seuil);
      var point = document.createElement('div');
      point.className = 'lao-jalon' + (ok ? ' est-atteint' : '');
      point.style.left = pos + '%';
      piste.appendChild(point);
      var l = document.createElement('div');
      l.className = ok ? 'est-atteint' : '';
      l.style.left = pos + '%';
      if (n >= 4) l.style.width = (100 / n) + '%';
      l.innerHTML = echapper(j.legende || '') + '<br>' + (j.drapeaux ? DRAPEAUX + ' ' : '') + echapper(argent(seuilCents(j.seuil)).replace(/,00(?=\s?\D*$)/, ''));
      leg.appendChild(l);
    });
  }

  var bandeauCourant = [], iBandeau = 0, minuterie = null, bandeauSuspendu = false;
  function rendreBandeau(etat) {
    var cle = etat.bandeau.join('|');
    var bloc = $('[data-lao-offres]');
    bloc.hidden = !etat.bandeau.length;
    if (cle === bandeauCourant.join('|')) return;
    bandeauCourant = etat.bandeau.slice();
    iBandeau = 0;
    var points = $('[data-lao-offre-points]');
    points.innerHTML = '';
    if (bandeauCourant.length > 1) {
      bandeauCourant.forEach(function (txt, i) {
        var b = document.createElement('button');
        b.type = 'button';
        var tmp = document.createElement('div'); tmp.innerHTML = txt;
        b.setAttribute('aria-label', 'Offre ' + (i + 1) + ' : ' + (tmp.textContent || '').trim());
        b.addEventListener('click', function () { montrerOffre(i); });
        points.appendChild(b);
      });
    }
    montrerOffre(0);
  }
  function montrerOffre(i) {
    iBandeau = i;
    var el = $('[data-lao-offre-texte]');
    el.innerHTML = bandeauCourant[i] || '';
    el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
    Array.prototype.forEach.call($('[data-lao-offre-points]').children, function (b, j) { b.setAttribute('aria-current', String(j === i)); });
  }
  function demarrerDefilement() {
    arreterDefilement();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var s = Math.max(2, Number(CFG.defilement) || 4);
    minuterie = setInterval(function () {
      if (bandeauSuspendu || bandeauCourant.length < 2) return;
      montrerOffre((iBandeau + 1) % bandeauCourant.length);
    }, s * 1000);
  }
  function arreterDefilement() { if (minuterie) clearInterval(minuterie); minuterie = null; }

  function retiresActifs() {
    var r = lireStockage(CLE_RETIRES, {});
    var maintenantMs = Date.now(), change = false;
    Object.keys(r).forEach(function (k) { if (!r[k] || maintenantMs - (r[k].le || 0) > DUREE_RETIRE) { delete r[k]; change = true; } });
    if (change) ecrireStockage(CLE_RETIRES, r);
    return r;
  }

  function rendreRemettre(etat) {
    var el = $('[data-lao-remettre]');
    var lignes = (donnees && donnees.lignes) || [];
    var total = (donnees && donnees.total) || 0;
    var r = retiresActifs();
    var html = '';
    Object.keys(r).forEach(function (k) {
      if (lignes.some(function (l) { return l.cadeau && norm(l.sku) === k; })) return;
      var j = etat.jalons.filter(function (x) { return x.cadeau && norm(x.sku) === k; })[0];
      if (!j || total < seuilCents(j.seuil)) return;
      if (etat.cliente && r[k].auto) return;
      html += '<div class="lao-remettre">' + echapper(r[k].nom) + ' retiré · <button type="button" class="lao-lien lao-lien--fort" data-lao-remettre="' + echapper(k) + '">le remettre</button></div>';
    });
    el.innerHTML = html;
  }

  function rendreCodes() {
    var appliques = (donnees && donnees.codes) || [];
    var tous = codesPanier.length ? codesPanier : appliques.map(function (c) { return { code: c, applicable: true }; });
    $('[data-lao-codes]').innerHTML = tous.map(function (c) {
      return '<span class="lao-code__puce' + (c.applicable ? '' : ' est-inactif') + '">' + echapper(String(c.code).toUpperCase()) + (c.applicable ? '' : ' (non applicable)') +
        ' <button type="button" data-lao-code-retirer="' + echapper(c.code) + '" aria-label="Retirer le code ' + echapper(c.code) + '">×</button></span>';
    }).join('');
    var actifs = tous.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
    $('[data-lao-code-resume]').textContent = actifs.length ? 'Code ' + actifs.join(', ').toUpperCase() + ' appliqué' : 'Code de réduction';
  }

  // « Vous aimerez aussi » : rendu par Shopify dans le contenu (prix, images, stock), recopié dans le pied, au-dessus de la barre de paliers.
  function rendreAccessoires() {
    var source = zone.querySelector('[data-lao-accessoires-source]');
    var cible = $('[data-lao-accessoires-zone]');
    if (!cible) return;
    if (source && donnees && donnees.nb) {
      if (cible.getAttribute('data-empreinte') !== source.innerHTML.length + ':' + source.textContent) {
        var defile = cible.querySelector('.lao-accessoires__rangee');
        var gauche = defile ? defile.scrollLeft : 0;
        cible.innerHTML = source.innerHTML;
        cible.setAttribute('data-empreinte', source.innerHTML.length + ':' + source.textContent);
        var nouvelle = cible.querySelector('.lao-accessoires__rangee'); if (nouvelle) nouvelle.scrollLeft = gauche;
      }
      cible.hidden = false;
    } else {
      cible.hidden = true;
      cible.innerHTML = '';
      cible.removeAttribute('data-empreinte');
    }
  }

  function rendre() {
    if (!donnees) donnees = lireDonnees(zone);
    if (!donnees) return;
    var etat = etatDuJour();
    var vide = !donnees.nb;
    $('[data-lao-vide]').hidden = !vide;
    $('[data-lao-vider]').hidden = vide;
    $('[data-lao-achat]').hidden = vide;
    $('[data-lao-total]').textContent = argent(donnees.total || 0);
    $('[data-lao-remises-panier]').innerHTML = (donnees.remisesPanier || []).map(function (r) {
      return '<div class="lao-remise-panier"><span>' + echapper(r.titre) + '</span><span>−' + echapper(argent(r.montant)) + '</span></div>';
    }).join('');
    if (donnees.note) $('[data-lao-mentions]').innerHTML = donnees.note;
    rendreBandeau(etat);
    rendreRoutine(etat);
    rendrePaliers(etat);
    rendreRemettre(etat);
    rendreCodes();
    rendreAccessoires();
    gererEchantillonCliente(etat);
    corrigerCadeaux();
    try { rendreLivraison(); } catch (e) {}
  }

  // ── Prix du point relais sous le total (28/10/2026) ───────────────────────
  // Au lieu de « frais de livraison calculés au paiement » : le VRAI tarif du point relais pour CE panier et le pays du visiteur,
  // lu dans les tarifs Shopify (/cart/shipping_rates.json, poids et seuil compris), jamais recopié ici. Pays de la livraison offerte
  // (réglage « lao_livraison_pays ») et pages en français seulement ; lecture impossible = mention d'origine gardée.
  var CP_PAYS = { FR: '75001', BE: '1000', LU: '1009', MC: '98000' };
  var livraisonCache = {}, livraisonCle = null;
  function rendreLivraison() {
    var span = $('[data-lao-mentions] [data-lao-note="standard"]');
    if (!span || !donnees || !donnees.nb || span.classList.contains('lao-masque')) return;
    if (!/^fr/i.test(document.documentElement.lang || 'fr')) return;
    var liv = CFG.livraison || {}, pays = String(CFG.pays || '').toUpperCase();
    var paysLiv = String(liv.pays || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
    if (!CP_PAYS[pays] || (paysLiv.length && paysLiv.indexOf(pays) < 0)) return;
    var cle = pays + '|' + (donnees.total || 0) + '|' + ((donnees.lignes || []).map(function (l) { return (l.cle || l.sku) + ':' + l.qte; }).join(','));
    livraisonCle = cle;
    var ecrire = function (prix) {
      if (livraisonCle !== cle || prix == null) return;
      var s = $('[data-lao-mentions] [data-lao-note="standard"]'); if (!s) return;
      var seuil = liv.actif && Number(liv.seuil) > 0 ? argent(seuilCents(liv.seuil)).replace(/,00(?=\s?\D*$)/, '') : '';
      s.textContent = prix <= 0 ? 'TTC, livraison en point relais offerte'
        : 'TTC, livraison en point relais : ' + argent(Math.round(prix * 100)) + (seuil ? ' (offerte dès ' + seuil + ')' : '');
    };
    if (cle in livraisonCache) { ecrire(livraisonCache[cle]); return; }
    var u = (CFG.routes.racine || '/').replace(/\/$/, '') + '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + pays + '&shipping_address%5Bzip%5D=' + CP_PAYS[pays];
    fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var relais = ((j && j.shipping_rates) || []).filter(function (r) { return /relais/i.test(r.name || ''); })
          .sort(function (a, b) { return Number(a.price) - Number(b.price); })[0];
        var prix = relais ? Number(relais.price) : null;
        if (prix != null && !isNaN(prix)) livraisonCache[cle] = prix;
        ecrire(isNaN(prix) ? null : prix);
      }).catch(function () {});
  }

  // Un cadeau offert ne se prend qu'à l'unité : une ligne cadeau à plus de 1 (quantité changée à la main, par exemple dans la console) est ramenée à 1.
  var correctionCadeau = false;
  function corrigerCadeaux() {
    var trop = ((donnees && donnees.lignes) || []).filter(function (l) { return l.cadeau && l.qte > 1; });
    if (!trop.length || correctionCadeau) return;
    correctionCadeau = true;
    var updates = {};
    trop.forEach(function (l) { updates[l.cle] = 1; });
    modifier(CFG.routes.maj, { updates: updates }).catch(function () {}).then(function () { correctionCadeau = false; });
  }

  // ── Échanges avec Shopify ─────────────────────────────────────────────────
  // Remplace le contenu par celui rendu par Shopify et rend le focus au même bouton (même ligne, même action).
  function appliquerHtml(html) {
    if (!html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var contenu = tmp.querySelector('[data-lao-contenu]');
    var d = lireDonnees(tmp);
    if (!contenu || !d) return false;
    var actif = document.activeElement, repere = null;
    if (actif && zone.contains(actif)) {
      var bloc = actif.closest('[data-lao-ligne]');
      var action = ['data-lao-plus', 'data-lao-moins', 'data-lao-supprimer', 'data-lao-retirer'].filter(function (a) { return actif.hasAttribute(a); })[0];
      if (bloc && action) repere = { variante: bloc.getAttribute('data-variante'), action: action };
    }
    zone.innerHTML = '';
    zone.appendChild(contenu);
    donnees = d;
    if (actif && !document.body.contains(actif)) {
      var cible = repere && zone.querySelector('[data-lao-ligne][data-variante="' + String(repere.variante).replace(/\D/g, '') + '"] [' + repere.action + ']');
      (cible || racine.querySelector('.lao-panier__fermer')).focus({ preventScroll: true });
    }
    return true;
  }
  var dernierCompte = null;
  function signalerTheme() {
    var nb = donnees ? donnees.nb : 0;
    if (nb === dernierCompte) return; // seulement si le nombre d'articles change (évite que d'autres scripts relisent le panier pour rien)
    dernierCompte = nb;
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cartCount: nb, source: 'lao-panier' } }));
  }
  function lirePanierJs() {
    return fetch(url(CFG.routes.panier, '.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { codesPanier = (c && c.discount_codes) || []; return c; })
      .catch(function () { return null; });
  }
  function urlSection() {
    // Rendu sur la route /cart (jamais mise en cache, comme le fait le thème pour son propre panier).
    var u = new URL(CFG.routes.panier || '/cart', location.origin);
    u.searchParams.set('section_id', SECTION);
    return u.toString();
  }
  function enFile(tache) { file = file.then(tache, tache); return file; }
  // Relecture complète (contenu rendu par Shopify + /cart.js pour les codes), dans la même file que les modifications.
  function charger() {
    return enFile(function () {
      var n = ++seq;
      racine.setAttribute('aria-busy', 'true');
      return Promise.all([
        fetch(urlSection(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }),
        lirePanierJs(),
      ]).then(function (res) {
        if (n === seq && appliquerHtml(res[0])) { rendre(); signalerTheme(); }
      }).catch(function () { if (n === seq) afficherErreur('Le panier n\'a pas pu être relu. Réessayez dans un instant.'); })
        .then(function () { if (n === seq) racine.removeAttribute('aria-busy'); });
    });
  }
  var minuterieChargement = null;
  function planifier() {
    if (!estOuvert() && !besoinDeDonnees()) return; // relu à l'ouverture
    clearTimeout(minuterieChargement);
    minuterieChargement = setTimeout(charger, 250);
  }
  // Volet fermé : on relit quand même si un cadeau « échantillon » doit être retiré chez une cliente reconnue.
  function besoinDeDonnees() { var e = palierEchantillon(); return !!(e && e.retirerClientes && estCliente()); }

  // Une modification à la fois. « corps » peut être une fonction évaluée au moment d'envoyer (quantité calculée sur l'état le plus récent : aucun clic perdu).
  function modifier(route, corps, options) {
    options = options || {};
    return enFile(function () {
      var c = typeof corps === 'function' ? corps() : corps;
      if (!c) return null;
      var n = ++seq;
      racine.setAttribute('aria-busy', 'true');
      effacerErreur();
      var payload = Object.assign({}, c, { sections: SECTION, sections_url: CFG.routes.panier || '/cart' });
      return fetch(url(route, '.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'erreur'); e.reponse = j; throw e; } return j; });
      }).then(function (j) {
        if (j && j.discount_codes) codesPanier = j.discount_codes;
        // Gift Box ignore les requêtes sans « updates / quantity / items » (code, vider) : on lui signale le changement pour qu'elle revoie les cadeaux.
        if (options.prevenirGiftBox) document.dispatchEvent(new CustomEvent('GIFTBOX_CART_UPDATED'));
        panierModifie = true;
        if (n === seq && j.sections && appliquerHtml(j.sections[SECTION])) { rendre(); signalerTheme(); annoncerPalier(); return j; }
        seq++; // contenu absent de la réponse : relecture complète juste après
        setTimeout(charger, 0);
        return j;
      }).catch(function (e) {
        afficherErreur((e && e.reponse && (e.reponse.description || e.reponse.message)) || 'La modification n\'a pas pu être faite. Réessayez.');
        setTimeout(charger, 0);
        throw e;
      }).then(function (j) { racine.removeAttribute('aria-busy'); return j; }, function (e) { racine.removeAttribute('aria-busy'); throw e; });
    });
  }
  // La clé d'une ligne change quand Shopify recalcule ses remises (passage d'un palier de la routine) : à défaut de clé, on retrouve la ligne par sa variante.
  function ligne(cle, variante) {
    var lignes = (donnees && donnees.lignes) || [];
    return lignes.filter(function (l) { return l.cle === cle; })[0] ||
      (variante ? lignes.filter(function (l) { return String(l.variante) === String(variante); })[0] : undefined);
  }

  function afficherErreur(texte) {
    var el = $('.lao-erreur');
    if (!el) { el = document.createElement('p'); el.className = 'lao-erreur'; el.setAttribute('role', 'alert'); $('[data-lao-corps]').prepend(el); }
    el.textContent = texte;
  }
  function effacerErreur() { var el = $('.lao-erreur'); if (el) el.remove(); }
  function annoncer(texte) { var a = $('[data-lao-annonce]'); a.textContent = ''; setTimeout(function () { a.textContent = texte; }, 60); }
  function annoncerPalier() {
    var m = $('[data-lao-palier-message]');
    var bloc = $('[data-lao-paliers]');
    annoncer('Panier mis à jour. Total ' + $('[data-lao-total]').textContent + (bloc.hidden ? '' : '. ' + m.textContent));
  }

  // ── Cadeaux Gift Box ──────────────────────────────────────────────────────
  // Gift Box garde ses cadeaux (et ceux refusés) dans localStorage « giftbox-added-offers » (champ « rejected », sans limite de durée).
  // On y note le refus comme son propre bouton le ferait, pour qu'elle ne remette pas le cadeau ; « le remettre » lève le refus et rajoute la ligne.
  function marquerRefusGiftBox(variante, refuse) {
    try {
      var liste = JSON.parse(localStorage.getItem(CLE_GIFTBOX) || '[]');
      if (!Array.isArray(liste)) return false;
      var touche = false;
      liste.forEach(function (o) { if (o && String(o.shopifyVariantId) === String(variante)) { o.rejected = refuse; touche = true; } });
      if (touche) { localStorage.setItem(CLE_GIFTBOX, JSON.stringify(liste)); window.dispatchEvent(new Event('offersUpdated')); }
      return touche;
    } catch (e) { return false; }
  }
  var retraitsEnCours = {};
  function retirerCadeau(l, auto) {
    if (retraitsEnCours[l.variante]) return Promise.resolve(null);
    retraitsEnCours[l.variante] = true;
    marquerRefusGiftBox(l.variante, true);
    var r = retiresActifs();
    r[norm(l.sku)] = { variante: l.variante, nom: l.nom, le: Date.now(), auto: !!auto };
    ecrireStockage(CLE_RETIRES, r);
    return modifier(CFG.routes.modif, function () {
      var actuelle = ligne(l.cle, l.variante);
      return actuelle ? { id: actuelle.cle, quantity: 0 } : null;
    }).then(function (j) { delete retraitsEnCours[l.variante]; return j; }, function (e) { delete retraitsEnCours[l.variante]; throw e; });
  }
  function remettreCadeau(skuNorm) {
    var r = retiresActifs();
    var info = r[skuNorm];
    if (!info) return;
    delete r[skuNorm];
    ecrireStockage(CLE_RETIRES, r);
    marquerRefusGiftBox(info.variante, false);
    tentativesRetrait = {};
    return modifier(CFG.routes.ajout, { items: [{ id: info.variante, quantity: 1 }] }).catch(function () { /* erreur déjà affichée */ });
  }
  function leverTousLesRefus() {
    var r = lireStockage(CLE_RETIRES, {});
    Object.keys(r).forEach(function (k) { if (r[k] && r[k].variante) marquerRefusGiftBox(r[k].variante, false); });
    ecrireStockage(CLE_RETIRES, null);
  }
  function palierEchantillon() { return (CFG.paliers || []).filter(function (p) { return p.cle === 'echantillon'; })[0]; }
  // Gift Box ne sait pas réserver un cadeau aux nouvelles clientes : chez une cliente reconnue, la ligne cadeau « échantillon » est retirée (refus noté, 2 essais au plus par page).
  function gererEchantillonCliente(etat) {
    var ech = palierEchantillon();
    if (!ech || !ech.retirerClientes || !ech.sku || !etat.cliente) return;
    ((donnees && donnees.lignes) || []).forEach(function (l) {
      if (!l.cadeau || norm(l.sku) !== norm(ech.sku)) return;
      var n = tentativesRetrait[l.variante] || 0;
      if (n >= 2 || retraitsEnCours[l.variante]) return;
      tentativesRetrait[l.variante] = n + 1;
      retirerCadeau(l, true).catch(function () {});
    });
  }

  // ── Interactions dans le volet ────────────────────────────────────────────
  function changerQuantite(cle, variante, delta) {
    return modifier(CFG.routes.modif, function () {
      var l = ligne(cle, variante);
      if (!l) return null;
      return { id: l.cle, quantity: delta === null ? 0 : Math.max(0, l.qte + delta) };
    }).catch(function () {});
  }
  racine.addEventListener('click', function (e) {
    var b = e.target.closest('button, [data-lao-fermer]');
    if (!b || !racine.contains(b)) return;
    if (b.hasAttribute('data-lao-fermer')) { fermer(); return; }
    var bloc = b.closest('[data-lao-ligne]');
    var cle = bloc && bloc.getAttribute('data-cle');
    var variante = bloc && bloc.getAttribute('data-variante');
    if (b.hasAttribute('data-lao-plus') && cle) changerQuantite(cle, variante, 1);
    else if (b.hasAttribute('data-lao-moins') && cle) changerQuantite(cle, variante, -1);
    else if (b.hasAttribute('data-lao-supprimer') && cle) changerQuantite(cle, variante, null);
    else if (b.hasAttribute('data-lao-retirer') && cle) { var l = ligne(cle, variante); if (l) retirerCadeau(l, false).catch(function () {}); }
    else if (b.hasAttribute('data-lao-remettre')) remettreCadeau(b.getAttribute('data-lao-remettre'));
    else if (b.hasAttribute('data-lao-ajouter')) {
      if (b.classList.contains('est-en-cours')) return;
      b.classList.add('est-en-cours');
      var idAjout = Number(b.getAttribute('data-lao-ajouter'));
      modifier(CFG.routes.ajout, { items: [{ id: idAjout, quantity: 1 }] }).catch(function () {}).then(function () { b.classList.remove('est-en-cours'); });
    }
    else if (b.hasAttribute('data-lao-vider')) { leverTousLesRefus(); modifier(CFG.routes.vider, {}, { prevenirGiftBox: true }).catch(function () {}); }
    else if (b.hasAttribute('data-lao-code-retirer')) changerCodes(null, b.getAttribute('data-lao-code-retirer'));
  });

  function changerCodes(ajout, retrait) {
    var info = $('[data-lao-code-info]');
    return lirePanierJs().then(function (c) {
      var liste = ((c && c.discount_codes) || []).map(function (x) { return x.code; });
      if (retrait) liste = liste.filter(function (x) { return x.toUpperCase() !== retrait.toUpperCase(); });
      if (ajout && !liste.some(function (x) { return x.toUpperCase() === ajout.toUpperCase(); })) liste.push(ajout);
      return modifier(CFG.routes.maj, { discount: liste.join(',') }, { prevenirGiftBox: true });
    }).then(function (j) {
      if (!ajout) { info.textContent = 'Code retiré.'; return; }
      var trouve = ((j && j.discount_codes) || []).filter(function (x) { return x.code.toUpperCase() === ajout.toUpperCase(); })[0];
      if (trouve && trouve.applicable) {
        info.textContent = '';
        $('[data-lao-code]').open = false; // le titre replié dit « Code … appliqué »
        annoncer('Code ' + String(trouve.code).toUpperCase() + ' appliqué.');
      } else {
        info.textContent = 'Code ' + ajout.toUpperCase() + ' : non applicable à ce panier (code inconnu, expiré ou conditions non remplies).';
      }
    }).catch(function () { info.textContent = 'Le code n\'a pas pu être vérifié. Réessayez.'; });
  }
  $('[data-lao-code-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var champ = this.querySelector('input');
    var code = champ.value.trim();
    if (!code) { $('[data-lao-code-info]').textContent = 'Saisissez un code.'; champ.focus(); return; }
    champ.value = '';
    changerCodes(code, null);
  });

  var bandeauEl = $('[data-lao-offres]');
  ['mouseenter', 'focusin'].forEach(function (n) { bandeauEl.addEventListener(n, function () { bandeauSuspendu = true; }); });
  ['mouseleave', 'focusout'].forEach(function (n) { bandeauEl.addEventListener(n, function () { bandeauSuspendu = false; }); });

  // ── Ouverture / fermeture ─────────────────────────────────────────────────
  var dernierFocus = null;
  var panierModifie = false; // sur la page /cart : la page d'origine est relue à la fermeture si le panier a changé
  function estOuvert() { return racine.classList.contains('est-ouvert'); }
  function ouvrir(origine) {
    if (!estOuvert()) dernierFocus = origine || document.activeElement;
    racine.hidden = false;
    document.documentElement.classList.add('lao-panier-ouvert');
    rendre();
    void volet.offsetWidth; // l'état fermé est posé avant la transition : le volet glisse
    racine.classList.add('est-ouvert');
    var f = racine.querySelector('.lao-panier__fermer');
    setTimeout(function () { if (f && !volet.contains(document.activeElement)) f.focus({ preventScroll: true }); }, 40);
    demarrerDefilement();
    charger();
  }
  function fermer() {
    racine.classList.remove('est-ouvert');
    document.documentElement.classList.remove('lao-panier-ouvert');
    arreterDefilement();
    setTimeout(function () { if (!estOuvert()) racine.hidden = true; }, 340);
    if (panierModifie && racine.hasAttribute('data-ouvrir-auto')) { location.reload(); return; }
    if (dernierFocus && dernierFocus.focus && document.body.contains(dernierFocus)) { try { dernierFocus.focus({ preventScroll: true }); } catch (e) { /* rien */ } }
  }
  function focusables() {
    return Array.prototype.filter.call(volet.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
  }
  document.addEventListener('keydown', function (e) {
    if (!estOuvert()) return;
    if (e.key === 'Escape') { e.preventDefault(); fermer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (!volet.contains(document.activeElement)) { e.preventDefault(); premier.focus(); }
    else if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  });

  // Icône panier de l'en-tête : ouvre le volet au lieu de la page panier (Cmd / Ctrl-clic : nouvel onglet comme d'habitude).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cart-toggle]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    e.preventDefault();
    e.stopPropagation();
    ouvrir(a);
  }, true);

  // ── Ajouts au panier de tout le site : rester sur la page, ouvrir seulement le volet (retour de Lisa du 25/10/2026) ──
  // ① tout formulaire « /cart/add » (fiches produit, fiches v2, ajout rapide, barre collante, page échantillon…), intercepté AVANT le thème ;
  // ② les liens « /cart/add?id=… » (landing Silicone) ; ③ l'événement « theme:cart:add » des boutons qui l'émettent sans formulaire soumis.
  // Le thème renverrait vers la page panier : ici on ajoute par la requête AJAX de Shopify et on ouvre le volet.
  function estAjoutPanier(action) {
    try { return /\/cart\/add(\.js)?$/.test(new URL(action, location.origin).pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/cart)/i, '')); } catch (e) { return false; }
  }
  function boutonOccupe(bouton, oui) {
    if (!bouton || !bouton.classList) return;
    if (oui) { bouton.classList.add('is-loading'); if ('disabled' in bouton) bouton.disabled = true; return; }
    setTimeout(function () {
      bouton.classList.remove('is-loading', 'is-added');
      var bloc = bouton.closest('[data-form-wrapper], .product__form, form');
      if ('disabled' in bouton && !(bloc && (bloc.classList.contains('variant--soldout') || bloc.classList.contains('variant--unavailable')))) bouton.disabled = false;
      var q = bouton.closest('[data-quick-add-holder]'); if (q) q.classList.remove('is-visible');
    }, 1000);
  }
  function envoyerAjout(fd, bouton) {
    fd.append('sections', SECTION);
    fd.append('sections_url', CFG.routes.panier || '/cart');
    boutonOccupe(bouton, true);
    return enFile(function () {
      var n = ++seq;
      return fetch(url(CFG.routes.ajout, '.js'), { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status) { erreurProduit(j, bouton); return; }
          if (bouton && bouton.classList) {
            bouton.classList.remove('is-loading');
            bouton.classList.add('is-added');
            bouton.dispatchEvent(new CustomEvent('theme:product:add', { detail: { response: j, button: bouton }, bubbles: true }));
          }
          // Ferme la fenêtre d'ajout rapide du thème (elle écoute cet événement ; le site n'a pas d'ancien tiroir panier à ouvrir).
          document.dispatchEvent(new CustomEvent('theme:product:added', { detail: { response: j, button: bouton }, bubbles: true }));
          if (typeof window.publish === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
            try { window.publish(window.theme.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: j }); } catch (err) { /* rien */ }
          }
          if (n === seq && j.sections && appliquerHtml(j.sections[SECTION])) { rendre(); signalerTheme(); }
          ouvrir(bouton);
        })
        .catch(function () { erreurProduit({ message: 'Erreur', description: 'Le produit n\'a pas pu être ajouté. Réessayez.' }, bouton); })
        .then(function () { boutonOccupe(bouton, false); });
    });
  }
  // Rend true si l'ajout est pris en charge (le formulaire ne doit alors pas partir).
  function ajouterFormulaire(form, bouton) {
    if (!form || form.querySelector('[type="file"]')) return false; // fichier joint : envoi classique du thème
    if (bouton && bouton.hasAttribute && bouton.hasAttribute('disabled') && !bouton.classList.contains('is-loading')) return true;
    if (bouton && bouton.classList && bouton.classList.contains('is-loading')) return true; // double clic
    if (!form.checkValidity()) { form.reportValidity(); return true; }
    var fd = new FormData(form);
    fd.delete('return_to');
    envoyerAjout(fd, bouton || form.querySelector('[type="submit"], [name="add"]'));
    return true;
  }
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !estAjoutPanier(form.getAttribute('action') || '')) return;
    if (ajouterFormulaire(form, e.submitter)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/cart/add"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    var u;
    try { u = new URL(a.href, location.origin); } catch (err) { return; }
    if (u.origin !== location.origin || !estAjoutPanier(u.pathname) || !u.searchParams.get('id')) return;
    e.preventDefault();
    e.stopPropagation();
    var fd = new FormData();
    fd.append('id', u.searchParams.get('id'));
    fd.append('quantity', u.searchParams.get('quantity') || '1');
    envoyerAjout(fd, a);
  }, true);
  window.addEventListener('theme:cart:add', function (e) {
    var bouton = e.detail && e.detail.button;
    if (!bouton) return;
    var form = bouton.form || bouton.closest('form');
    if (!form || form.querySelector('[type="file"]')) return; // cas non géré : comportement du thème
    e.stopImmediatePropagation();
    ajouterFormulaire(form, bouton);
  }, true);

  function erreurProduit(data, bouton) {
    if (!bouton || !bouton.closest) { ouvrir(); afficherErreur(data.description || data.message || 'Erreur'); return; }
    bouton.classList.remove('is-loading');
    var conteneur = (bouton.closest('[data-quick-add-holder]') || bouton.closest('[data-quick-add-modal]') || bouton.closest('[data-section-id]'));
    var zoneErr = conteneur && conteneur.querySelector('[data-cart-errors-container]');
    var texte = data.message && data.description && data.message !== data.description ? data.message + ' : ' + data.description : (data.description || data.message || 'Erreur');
    if (zoneErr) {
      zoneErr.innerHTML = '<div class="errors">' + echapper(texte) + '</div>';
      zoneErr.classList.add('is-visible');
    } else {
      ouvrir(bouton);
      afficherErreur(texte);
    }
    bouton.dispatchEvent(new CustomEvent('theme:product:add-error', { detail: { response: data, button: bouton }, bubbles: true }));
  }

  // Lecteur vidéo PlayShorts : son bouton « voir le panier » ouvre le volet au lieu de la page panier.
  window.addEventListener('PLAYSHORTS_SHOW_CART', function (e) { e.stopImmediatePropagation(); ouvrir(); }, true);

  // ── Changements faits ailleurs (appli Gift Box, autre onglet, script échantillon, PlayShorts) ──
  // Gift Box appelle cette fonction après chaque ajout / retrait de cadeau qu'elle fait elle-même (définie aussi dans sections/lao-panier.liquid).
  window.GIFTBOX_CUSTOM_UPDATE_CART = function () { planifier(); };
  ['cart:build', 'cart:refresh', 'cartdrawer:refresh', 'dispatch:cart-drawer:refresh', 'theme:cart:refresh', 'GIFTBOX_CART_UPDATED', 'PLAYSHORTS_ADD_TO_CART_RESPONSE'].forEach(function (nom) {
    document.addEventListener(nom, planifier);
  });
  document.addEventListener('theme:cart:change', function (e) { if (!(e.detail && e.detail.source === 'lao-panier')) planifier(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') planifier(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) planifier(); });

  // Gift Box ne se montre que pendant une offre ponctuelle (cadeau daté : offres A et B des réglages). Hors offre, son lanceur et sa fenêtre sont masqués ; les cadeaux permanents restent dans le volet.
  function majGiftBoxPonctuel() {
    var t = maintenant();
    var ponctuelle = (CFG.offres || []).some(function (o) { return o.actif && o.sku && Number(o.seuil) > 0 && dansFenetre(o.debut, o.fin, t); });
    document.documentElement.classList.toggle('lao-giftbox-hors-offre', !ponctuelle);
  }
  majGiftBoxPonctuel();
  setInterval(majGiftBoxPonctuel, 60000);

  // Juste avant le paiement : le panier est relu chez Shopify et tout cadeau à plus de 1 est ramené à 1 (Gift Box ne le contrôle qu'au chargement d'une page).
  function estCadeauJs(i) { return i.product_type === 'giftbox_ghost_product' || /^VOTRE CADEAU/i.test(String(i.product_title || i.title || '')); }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('lao-commander-form')) return;
    if (form.getAttribute('data-lao-verifie') === '1') { form.removeAttribute('data-lao-verifie'); return; }
    e.preventDefault();
    var bouton = e.submitter || form.querySelector('[name="checkout"]');
    lirePanierJs().then(function (c) {
      var updates = {};
      ((c && c.items) || []).forEach(function (i) { if (i.quantity > 1 && estCadeauJs(i)) updates[i.key] = 1; });
      if (!Object.keys(updates).length) return null;
      return fetch(url(CFG.routes.maj, '.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }).catch(function () {}).then(function () {
      form.setAttribute('data-lao-verifie', '1');
      if (form.requestSubmit) form.requestSubmit(bouton || undefined); else form.submit();
    });
  }, true);

  window.LaoPanier = { ouvrir: ouvrir, fermer: fermer, rafraichir: charger, etat: function () { return { donnees: donnees, codes: codesPanier, jour: etatDuJour() }; } };
  rendre();
  dernierCompte = donnees ? donnees.nb : null;
  // Renvoi depuis la page panier (snippets/lao-panier-sans-page-panier.liquid) : ouvrir le volet puis retirer le paramètre de l'adresse.
  try {
    var adresse = new URL(location.href);
    if (adresse.searchParams.get('panier') === 'ouvert') {
      adresse.searchParams.delete('panier');
      history.replaceState(history.state, '', adresse.pathname + adresse.search + adresse.hash);
      ouvrir();
    }
  } catch (e) { /* rien */ }
  chargerCollections();
})();
